import { render, staticRenderFns } from "./DesafiosEquipesList.vue?vue&type=template&id=b8638942&scoped=true&"
import script from "./DesafiosEquipesList.vue?vue&type=script&lang=js&"
export * from "./DesafiosEquipesList.vue?vue&type=script&lang=js&"
import style0 from "./DesafiosEquipesList.vue?vue&type=style&index=0&id=b8638942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8638942",
  null
  
)

export default component.exports